import React, {useEffect} from 'react';
import Box from '@/Atoms/Box/Box';
import CCText from '@/Atoms/CCText';
import {useTimer} from 'react-timer-hook';

interface ClassEndCountdownProps {
  expiryTimestamp: Date;
  onExpire: () => void;
  onLowTime: () => void;
  boxStyle?: any;
  textStyle?: any;
  fontSize?: number;
}

// Isolated so the once-a-second re-render it causes doesn't cascade up into
// the Classroom root (and from there into every tab it renders).
const ClassEndCountdown = React.memo(
  ({
    expiryTimestamp,
    onExpire,
    onLowTime,
    boxStyle,
    textStyle,
    fontSize,
  }: ClassEndCountdownProps) => {
    const {seconds, minutes, isRunning} = useTimer({
      expiryTimestamp,
      autoStart: true,
      onExpire,
    });

    // Intentionally matches the pre-extraction expression (ignores hours).
    const lowTime = isRunning && minutes * 60 + seconds <= 120;

    useEffect(() => {
      if (lowTime) {
        onLowTime();
      }
    }, [lowTime, onLowTime]);

    if (!isRunning) {
      return null;
    }

    return (
      <Box style={boxStyle}>
        <CCText style={textStyle} fontSize={fontSize}>
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </CCText>
      </Box>
    );
  },
);

export default ClassEndCountdown;
